import { Link } from "react-router-dom";
import { ArrowUpRight, Flame } from "lucide-react";
import NumberRollup from "@/components/NumberRollup";

/**
 * Current savings streak card — the wide amber-on-forest banner between
 * the north-star grid and the mid-dashboard cards. Extracted in iter-31.
 * Renders nothing when `streak` is null.
 */
export default function StreakBanner({ streak }) {
  if (!streak) return null;

  return (
    <Link to="/streak" className="block mb-6" data-testid="dashboard-streak-banner">
      <div
        className="card-flat p-5 relative overflow-hidden group cursor-pointer animate-fadeup"
        style={{
          background: "linear-gradient(120deg, #21422F 0%, #2D5A40 60%, #437A55 100%)",
          color: "#FDFCFB",
          borderColor: "transparent",
        }}
      >
        <div
          className="absolute -top-14 -right-8 h-40 w-40 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(224,158,80,0.35) 0%, rgba(224,158,80,0) 70%)" }}
        />
        <div className="relative flex items-center justify-between gap-6 flex-wrap">
          <div className="flex items-center gap-4">
            <div
              className="h-12 w-12 rounded-xl flex items-center justify-center"
              style={{ background: "rgba(0,0,0,0.22)" }}
            >
              <Flame size={22} color="#E09E50" className="flame-flicker"/>
            </div>
            <div>
              <div className="text-[10px] tracking-[0.24em] uppercase" style={{ opacity: 0.7 }}>
                Current savings streak
              </div>
              <div className="flex items-baseline gap-2 mt-1">
                <div
                  className="font-mono font-medium leading-none"
                  style={{ fontSize: "2rem", letterSpacing: "-0.02em" }}
                  data-testid="dashboard-streak-count"
                >
                  <NumberRollup value={streak.current_streak} duration={700} />
                </div>
                <div className="text-sm" style={{ opacity: 0.85 }}>
                  month{streak.current_streak === 1 ? "" : "s"}
                </div>
              </div>
            </div>
          </div>
          <div className="text-sm max-w-md" style={{ opacity: 0.9 }}>
            {streak.next_milestone
              ? <>
                  Just <span className="font-mono font-medium" style={{ color: "#E09E50" }}>
                    {streak.months_to_next}
                  </span> more to unlock <span style={{ fontWeight: 600 }}>{streak.next_milestone.name}</span>{" "}
                  {streak.next_milestone.tier === "pro" && <span className="badge badge-warn ml-1">PRO</span>}
                </>
              : "You've reached Legend tier. Absolute discipline."}
          </div>
          <div
            className="text-xs flex items-center gap-1.5 transition-transform group-hover:translate-x-1"
            style={{ opacity: 0.9 }}
          >
            View streak <ArrowUpRight size={14}/>
          </div>
        </div>
      </div>
    </Link>
  );
}
